'use client'

import { useSession } from 'next-auth/react'
import { useCart } from './useCart'
import {
  filterDiscounts, formatImageURL, getEffectivePrice, getStrikethroughPrice,
  getRewardItemPrice, getCouponPriceForVariant, getLoyaltyProductDiscount, isDiscountBetter,
} from '@/utils/util'
import { getVariantDimension } from '@/utils/order'

export function useCartItem(product: any) {
  const { data: session } = useSession()
  const { loading, addOne, removeOne, removeFromCart, removeRewardItem, appliedCoupon, loyaltySummary, loyaltyCategoryParents } = useCart()

  const productData = product.product || product
  const variant = product.variant
  const qty = product.quantity || 1
  const isReward = product.isRewardItem
  const discounts = filterDiscounts(productData?.discounts, !!session?.user?.id, variant?.id)

  let unitPrice: number
  let displayPrice: number
  let originalPrice: number | null = null
  let loyaltyDeal: any = null

  if (isReward) {
    unitPrice = getRewardItemPrice(product)
    displayPrice = unitPrice * qty
    originalPrice = variant.price
  } else {
    const effectivePrice = getEffectivePrice(variant, discounts, !!session?.user?.id)
    const strikethroughPrice = getStrikethroughPrice(variant, discounts, !!session?.user?.id)
    const couponPrice = getCouponPriceForVariant(variant, appliedCoupon, productData)
    if (couponPrice !== null) {
      unitPrice = couponPrice
      displayPrice = couponPrice * qty
      originalPrice = variant.price
    } else {
      unitPrice = effectivePrice ?? variant.price
      displayPrice = unitPrice * qty
      originalPrice = effectivePrice !== null ? strikethroughPrice : null
    }
    loyaltyDeal = getLoyaltyProductDiscount({ product: productData, variant, summary: loyaltySummary, categoryParents: loyaltyCategoryParents, hasOtherDiscount: couponPrice !== null || (discounts?.length > 0 && isDiscountBetter(variant, discounts, !!session?.user?.id)) })
    if (loyaltyDeal) {
      unitPrice = Math.max(0, unitPrice - loyaltyDeal.unitSaving)
      displayPrice = unitPrice * qty
      originalPrice = variant.price
    }
  }

  const showDiscountedPrice = originalPrice !== null && unitPrice < (originalPrice || 0)
  const discountName = isReward
    ? product.discountName
    : discounts?.find((d: any) => d.type === 'productDiscount' && d.method === 'automatic')?.name
      || (appliedCoupon?.discount || appliedCoupon)?.name

  const imageUrl = variant?.images?.length > 0 ? formatImageURL(variant.images[0]) : formatImageURL('placeholder.png')
  const productName = productData?.name || product?.name || 'Бүтээгдэхүүн'
  const productCustomId = productData?.customId || product?.customId
  const dimension = getVariantDimension(variant)
  const isOutOfStock = !isReward && (product.quantity === 0 || product.isOutOfStock)
  const showVariantName = !!(variant?.name && !(variant.id === productData?.defaultVariantId && variant.name === 'Үндсэн төрөл'))

  const handleRemove = () => {
    if (isReward) {
      removeRewardItem(product.id, variant.id, product.discountType || 'buyXgetY')
    } else {
      removeFromCart({ productId: product.id, variantId: variant.id })
    }
  }

  const handleAddOne = () => addOne({ productId: product.id, variantId: variant.id })
  const handleRemoveOne = () => removeOne({ productId: product.id, variantId: variant.id })

  return {
    productData, variant, qty, isReward, isOutOfStock,
    unitPrice, displayPrice, originalPrice, showDiscountedPrice, loyaltyDeal,
    discountName, imageUrl, productName, productCustomId,
    dimension, showVariantName,
    loading,
    handleRemove, handleAddOne, handleRemoveOne,
  }
}
